export class ApiError extends Error {
    constructor(
        readonly code: string,
        readonly error: { message: string }[],
    ) {
        super(error.map(({ message }) => message).join('\n'));
    }

    static async fromResponse(response: Response) {
        const { code, error } = await response.json();

        if (code) {
            if (typeof error === 'string') {
                throw new ApiError(code, [{ message: error }]);
            }

            if (Array.isArray(error) && error[0]?.message) {
                throw new ApiError(code, error as { message: string }[]);
            }

            throw new ApiError(code, [{ message: 'No error message is provided' }]);
        }

        throw new ApiError('UNKNOWN_ERROR', [{ message: 'Unhandled error' }]);
    }
}
